import React from 'react';

const sizeMap = {
  4: 'w-4 h-4',
  5: 'w-5 h-5',
  6: 'w-6 h-6',
  8: 'w-8 h-8',
};

const Checkbox = React.forwardRef(
  (
    {
      className = '',
      disabled = false,
      size = 5, // use single prop instead of width/height
      checked,
      ...props
    },
    ref
  ) => {
    const sizeClass = sizeMap[size] || 'w-5 h-5';

    return (
      <div className={`relative inline-flex ${sizeClass}`}>
        {/* Hidden Native Checkbox */}
        <input
          type="checkbox"
          ref={ref}
          disabled={disabled}
          checked={checked}
          className={`absolute top-0 left-0 ${sizeClass} opacity-0 cursor-pointer ${
            disabled ? 'cursor-not-allowed' : ''
          } ${className}`}
          {...props}
        />

        {/* Custom Checkbox UI */}
        <div
          className={`${sizeClass} border rounded flex items-center justify-center transition-colors
            ${
              checked
                ? 'border-[#115B9D] bg-white'
                : 'border-gray-300 bg-white'
            }
            ${disabled ? 'opacity-50' : ''}
          `}
        >
          {checked && (
            <svg
              className="w-4 h-4 text-[#115B9D] pointer-events-none"
              viewBox="0 0 20 20"
              fill="currentColor"
            >
              <path
                fillRule="evenodd"
                d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                clipRule="evenodd"
                stroke="currentColor"
                strokeWidth="0.3"
              />
            </svg>
          )}
        </div>
      </div>
    );
  }
);

Checkbox.displayName = 'Checkbox';

export default Checkbox;